import { render, staticRenderFns } from "./TemplatesIA.vue?vue&type=template&id=18c8ebc2"
import script from "./TemplatesIA.vue?vue&type=script&lang=js"
export * from "./TemplatesIA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports